/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetChartModel,
  IGetChartRequest,
  IMappers,
  IGetChartResponse,
  IGetChartResponseError,
  TGetChartResponse,
} from './types';

const defaultConfig: TGetChartModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'valuation-market-analytics',
  pathApi: '/v1/get-chart/',
  hostType: 'api',
} as TGetChartModel;

function createGetChartModel(parameters: IGetChartRequest): TGetChartModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetChartOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetChartRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetChart<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetChartOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetChartResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetChartModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetChartResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetChartResponseError);
    }
  }

  return { response, statusCode } as TGetChartResponse;
}

export { defaultConfig, createGetChartModel, fetchGetChart };
